import script from "./GraphDemo.vue?vue&type=script&setup=true&lang=js"
export * from "./GraphDemo.vue?vue&type=script&setup=true&lang=js"

import "./GraphDemo.vue?vue&type=style&index=0&id=3dc1f870&lang=css"

const __exports__ = script;

export default __exports__